export const mapReviewStatus = ({ record, reviewStatusCounts }) => {
  const noReview = { color: "grey", text: "No review" };
  if (!reviewStatusCounts || reviewStatusCounts.length < 1) {
    return noReview;
  }

  const review = record.compliance.review;
  const currentReviewStatus = record.compliance.currentReviewStatus;

  const due = reviewStatusCounts.find((x) => x.key === 3);
  const notDue = reviewStatusCounts.find((x) => x.key === 4);

  // Direct index mapping approach
  if (review?.isDue) return due;
  if (review?.isNotDue) return notDue;
  if (currentReviewStatus?.name === "No Review") return noReview;

  return noReview;
};

export const capitalized = (str) =>
  str.replace(/^./, (char) => char.toUpperCase());

export const mapCustomerStatus = (selectedCustomer) =>
  selectedCustomer
    ? selectedCustomer.isVulnerable
      ? "Vulnerable Customer"
      : selectedCustomer.isTakingABreak
        ? "Temporary Break"
        : selectedCustomer.isBarred
          ? "Permanently Barred"
          : "Normal"
    : "Normal";

export const mapStatusToCustomer = ({ customerStatus, customer }) => {
  if (!customer || !customerStatus) return;
  const status = customerStatus.value;

  const updatedCustomer = {
    ...customer,
    isNormal: false,
    isVulnerable: false,
    isTakingABreak: false,
    isBarred: false,
  };

  status === "isNormal"
    ? (updatedCustomer.isNormal = true)
    : status === "isVulnerable"
      ? (updatedCustomer.isVulnerable = true)
      : status === "isTakingABreak"
        ? (updatedCustomer.isTakingABreak = true)
        : status === "isBarred"
          ? (updatedCustomer.isBarred = true)
          : (updatedCustomer.isNormal = true);

  return updatedCustomer;
};

export const mapCustomerStatusOption = ({ customer, customerStatusOptions }) =>
  customer
    ? customer.isVulnerable
      ? customerStatusOptions[1]
      : customer.isTakingABreak
        ? customerStatusOptions[2]
        : customer.isBarred
          ? customerStatusOptions[3]
          : customerStatusOptions[0]
    : customerStatusOptions[0];

export const mapCustomerReviewStatus = (record) => {
  const status = record?.customer?.currentReview;

  const due = { color: "green", content: "Due" };
  const notDue = { color: "orange", content: "Not Due" };
  const none = { color: "grey", content: "No Review" };
  const completed = { color: "blue", content: "Completed" };

  return status?.isDue
    ? due
    : status?.isNotDue
      ? notDue
      : status?.isClosed
        ? completed
        : none;
};
